export const eventOperations = {
    LLM_RESPONSE: 'LLM_RESPONSE',
    LLM_TRIGGER: 'LLM_TRIGGER',
    SYSTEM_PROMPT: 'SYSTEM_PROMPT',
    RETURN_REQUEST: 'RETURN_REQUEST',
    USER_EDIT: '≈',
    CONVERSER_VALIDATOR: 'CONVERSER_VALIDATOR',
};

export const operationOrder = {
    [eventOperations.SYSTEM_PROMPT]: 2,
    [eventOperations.LLM_TRIGGER]: 3,
    [eventOperations.LLM_RESPONSE]: 4,
    [eventOperations.RETURN_REQUEST]: 5,
    [eventOperations.CONVERSER_VALIDATOR]: 6,
};

export const TEMPLATE_METADATA_ID = 7;
